module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-60x60-10386d45f0191f5646ee557d00b621a6.png";